var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11490_9965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99989 12.0581C6.90949 12.0581 6.0224 12.9452 6.0224 14.0356C6.12181 16.6554 9.87838 16.6547 9.97738 14.0356C9.97738 12.9452 9.09026 12.0581 7.99989 12.0581Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97643 0.913178C8.99513 -0.304106 7.00522 -0.3047 6.02352 0.91324C5.53193 1.49848 5.32554 2.26576 5.4573 3.01833C5.8502 5.26319 6.40468 8.43152 6.65353 9.85444C6.93235 11.3522 9.06773 11.3517 9.3462 9.8545L10.5427 3.01833C10.6744 2.26579 10.4681 1.49848 9.97643 0.913178Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11490_9965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/priority.afcacb9c50080fd1298a370194290c6b.svg";
export { ForwardRef as ReactComponent };